export default __webpack_public_path__ + "static/media/cloudant.310ecc22.svg";